import { ABaseTableFilter } from 'views/components/TableFilters/ABaseTableFilter'
import { t } from 'i18next'
import { endpoints } from 'modules/endpoints'
import { ListRequestParams } from 'modules/domain/types'
import { FC } from 'react'

interface Props {
  listRequestParams: ListRequestParams
  updateFilterState: (filterObj: Record<string, string>) => void
  placeholder?: string
}

export const ExecutorFilter: FC<Props> = ({
  updateFilterState,
  listRequestParams,
  placeholder = t('bid:filterByExecutor'),
}) => {
  return (
    <ABaseTableFilter
      onChange={(responsible) => updateFilterState({ responsible })}
      value={listRequestParams.filter.responsible}
      placeholder={placeholder}
      getLabel={(label) => label.full_name}
      endpoint={endpoints.taskAssignees()}
      searchField="search"
      id="coordinatorFilter"
      simpleApiFormat
    />
  )
}
